import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class ParagraphNewsletteranmeldung extends Component {
  render() {
    const sectionClassNames = classNames({
      "paragraph paragraph-newsletter-register": true,
      "background-color": this.props.content.fieldFarbigHinterlegen,
    });
    return (
      <section className={sectionClassNames}>
        <div className="container">
          <div className="row">
            <div className="col-10">
              <div
                className="newsletter-embedd"
                dangerouslySetInnerHTML={{
                  __html: this.props.content?.fieldCodeText,
                }}
              />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

ParagraphNewsletteranmeldung.propTypes = {
  content: PropTypes.shape({
    fieldCodeText: PropTypes.string,
    fieldText: PropTypes.shape({
      processed: PropTypes.string,
    }),
  }),
};

export default ParagraphNewsletteranmeldung;
